import React from 'react';
import EditVideoState from './editVideoState/EditVideoState';
import EditVideoControlPanel from './components/EditVideoControlPanel/EditVideoControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

const EditVideoPage: React.FC = () => {
	return (
		<EditVideoState>
			<EditVideoControlPanel />
			<Forms />
			<ModalWindows />
		</EditVideoState>
	);
};

export default EditVideoPage;
